export default function setChangeColorButtonHandler(imageSelector, buttonSelector, colorSelector) {
    $(document).on('click', buttonSelector, function ChangeColorButtonHandler() {
        let $self = $(this);
        let image = $self.data('image');
        let $jsChangeColorImage = $(imageSelector);
        if (image && $jsChangeColorImage.length) {
            $jsChangeColorImage[0].onload = function () {
                $(document).trigger('changeColorImageOnload', {$target: $self});
            };
            $jsChangeColorImage.attr('src', image);
        }

        let colorname = $(this).data('colorname');
        let $jsColorName = $(colorSelector);
        if (colorname && $jsColorName.length) {
            $jsColorName.text(colorname);
        }
        $self.parent().find("div").removeClass('active');
        $self.addClass('active');
        
    });
}
